import './HeroCard.css'
const HeroCard = ({ image, name, title, description, isSquare }) => {
    return <div>
        <div className="hero-card">
            <div
                className={`hero-image-wrapper ${isSquare ? "square" : "circle"
                    }`}
            >
                <img src={image} alt={name} className="hero-image" />
            </div>
            <h2 className="hero-name">{name}</h2>
            <h4 className="hero-title">{title}</h4>
            <p className="hero-description">{description}</p>
        </div>
    </div>;
};

export default HeroCard;